import { PROVIDERS } from '@sportsbook/constants';

import { BreadCrumbsOutrightLabel } from '../components/bread-crumbs/bread-crumbs-outright-label/bread-crumbs-outright-label';
import { PAGES_PATHS } from '../page-paths';

export const BREADCRUMB_TYPES = {
  SPORTSLIST: 'sportsList',
  OUTRIGHTSLIST: 'outrightsList',
  LEAGUESLIST: 'leaguesList',
  MATCHESLIST: 'matchesList',
};

export const getTargetUrl = (breadCrumbType, data, isLive) => {
  switch (breadCrumbType) {
    case BREADCRUMB_TYPES.SPORTSLIST:
      return isLive ? `${PAGES_PATHS.LIVE}?sport=${data.sportKey}` : `/${data.sportKey}`;
    case BREADCRUMB_TYPES.OUTRIGHTSLIST:
      return `/${data.sportKey}/${data.categorySlug}-c-${data.categoryId}`;
    case BREADCRUMB_TYPES.LEAGUESLIST:
      return `/${data.sportKey}/${data.leagueSlug}-l-${data.leagueId}`;
    default:
      return `/${data.sportKey}/${data.matchSlug}-m-${data.matchId}`;
  }
};

export function shouldDisplayCategory(provider) {
  return provider !== PROVIDERS.ODDIN;
}

export function getLeagueLabel(league) {
  return shouldDisplayCategory(league.provider) ? `${league.categoryName}, ${league.leagueName}` : league.leagueName;
}

const createCrumb = (key, label, data, breadCrumbType) => ({ key, label, data, breadCrumbType });

const getGameLabel = (a, b) => `${a} - ${b}`;

export const getCrumbItems = (data = {}) => {
  const { sportKey, sportName, categoryName, leagueId, matchId, nameA, nameB, categoryId } = data;
  const items = [];

  if (!sportKey) return items;
  items.push(createCrumb(sportKey, sportName, data, BREADCRUMB_TYPES.SPORTSLIST));

  if (categoryId && !leagueId) {
    items.push(
      createCrumb(
        categoryId,
        <BreadCrumbsOutrightLabel categoryName={categoryName} />,
        data,
        BREADCRUMB_TYPES.OUTRIGHTSLIST
      )
    );
  }

  if (!leagueId) return items;
  items.push(createCrumb(leagueId, getLeagueLabel(data), data, BREADCRUMB_TYPES.LEAGUESLIST));

  if (!matchId) return items;
  items.push(createCrumb(matchId, getGameLabel(nameA, nameB), data, BREADCRUMB_TYPES.MATCHESLIST));

  return items;
};

const createDropdownItem = (key, label, data, isLive = false) => ({ key, label, data, isLive });

export const sportToBreadcrumbDropdownItem = sport => createDropdownItem(sport.sportKey, sport.sportName, sport);

export const categoryToBreadcrumbDropdownItem = category =>
  createDropdownItem(category.categoryId, <BreadCrumbsOutrightLabel categoryName={category.categoryName} />, category);

export const leagueToBreadcrumbDropdownItem = league =>
  createDropdownItem(league.leagueId, getLeagueLabel(league), league);

export const gameToBreadcrumbDropdownItem = game =>
  createDropdownItem(game.matchId, getGameLabel(game.nameA, game.nameB), game, game.isLive);
